import { Link } from "react-router-dom";
import { Star } from "lucide-react";

const SiteFooter = () => (
  <footer className="border-t border-border/50 bg-card">
    <div className="container py-8 sm:py-10">
      <div className="flex flex-col items-center gap-4 sm:gap-6 text-center md:flex-row md:justify-between md:text-left">
        <div>
          <span className="font-display text-lg font-bold text-foreground">
            heilys<span className="text-primary">.info</span>
          </span>
          <p className="mt-1 max-w-md text-[11px] sm:text-xs text-muted-foreground">
            Unabhängige Orientierung zu heilys Produkten und Rotlichtanwendungen für zuhause. Kein offizieller Shop – bei Käufen über Partnerlinks erhalten wir eine Provision.
          </p>
          <p className="mt-2 inline-flex items-center gap-1 text-[11px] text-muted-foreground/70 sm:text-xs">
            <Star className="h-3 w-3 fill-primary text-primary" aria-hidden="true" />
            <span>4,76 / 5 bei Trusted Shops*</span>
          </p>
        </div>
        <nav className="flex flex-wrap justify-center gap-4 sm:gap-6 text-xs sm:text-sm text-muted-foreground">
          <Link to="/" className="hover:text-foreground transition-colors">Start</Link>
          <Link to="/transparenz" className="hover:text-foreground transition-colors">Transparenz</Link>
          <Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link>
        </nav>
      </div>
      <p className="mt-4 sm:mt-6 text-center text-[11px] sm:text-xs text-muted-foreground/60">
        © {new Date().getFullYear()} heilys.info · Alle Rechte vorbehalten · *Bewertung laut Trusted Shops zum Zeitpunkt der letzten Recherche
      </p>
    </div>
  </footer>
);

export default SiteFooter;
